import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { VAutocompleteComponent } from '@app/directives/_forms/v-autocomplete/v-autocomplete.component';
import { IPill } from '@app/directives/_veri/v-pills/v-pills.component';
import { IReseller } from '@app/main/modules/foundation/_models/IReseller';
import { AccountService } from '@app/main/modules/foundation/_services/account.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import './reseller-selector.component.scss';

@UntilDestroy()
@Component({
    selector: "reseller-selector",
    template: require("./reseller-selector.component.html")
})
export class ResellerSelectComponent implements OnInit, OnChanges {
    @Input() selectedResellerIds: number[] = [];
    @Input() disabled: boolean;
    //@Input() resellerId: number;
    @Input() titleKey: string = 'EngineerJobs.AssignEngineer';
    @Output() selectionChanged = new EventEmitter<number[]>();

    //selectedResellers: IReseller[] = [];
    allResellers: IReseller[];
    availableResellers: IReseller[];
    loading: boolean = true;
    resellerPills: IPill<IReseller>[] = [];

    selectedResellerId = -1;

    @ViewChild('resellerAutocomplete') dropdown: VAutocompleteComponent<IReseller>;
    
    constructor(
        private readonly accountService: AccountService
        ) { }

    ngOnInit(): void {
        this.load();
    }

    ngOnChanges(): void {
        this.renderPills();
    }

    onResellerClicked(reseller: IReseller): void {
        if (this.disabled) {
            return;
        }
        this.dropdown?.clearInput();

        this.addPill(reseller);

        this.selectedResellerIds = this.resellerPills.map(pill => {
            return pill.data.Id;
        });

        const resellerIndex = this.availableResellers.findIndex(r => r.Id == reseller.Id);

        this.availableResellers.splice(resellerIndex, 1);

        this.selectionChanged.emit(this.selectedResellerIds);


    }

    onResellerRemoved(pill: IPill<IReseller>): void {
        if (this.disabled) {
            return;
        }
        const reseller = pill.data;
        const selectedResellerIndex = this.selectedResellerIds.findIndex(id => id === reseller.Id);

        if (selectedResellerIndex < 0) {
            this.renderPills();
            return;
        }

        this.availableResellers.push(reseller);

        this.selectedResellerIds.splice(selectedResellerIndex, 1);
        this.renderPills();
        this.selectionChanged.emit(this.selectedResellerIds);
    }

    resellerSearchPredicate(reseller: IReseller, text: string): boolean {
        return reseller.Description?.toLowerCase().includes(text.toLowerCase());
    }

    //--

    private load(): void {
        this.renderPills();
        this.loadResellers();
    }

    private loadResellers(): void {
        this.loading = true;

        this.accountService.getResellers().pipe(untilDestroyed(this)).subscribe(resellers => {
            this.allResellers = resellers;
            
            this.availableResellers = this.allResellers.filter(reseller => {
                return !this.selectedResellerIds.find(id => id == reseller.Id);
            });

            this.selectedResellerIds.forEach(id => {
                this.addPill(this.allResellers.find(r => r.Id === id));
            })

            this.loading = false;
        });
    }

    private renderPills(): void {
        this.resellerPills = [];
        if (!this.selectedResellerIds.length || !this.allResellers) {
            return;
        }

        this.selectedResellerIds.forEach(id => {
            this.addPill(this.allResellers.find(r => r.Id === id));
        })
    }

    private addPill(reseller: IReseller): void {
        if (!!this.resellerPills.find(pill => pill.data.Id === reseller.Id)) {
            return;
        }
        this.resellerPills.push({
            data: reseller,
            label: reseller.Description,
            icon: 'close'
        })
    }
}
